import React from "react";
import "./Home.css";
import Product from "./Product";
function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <div
          id="carouselExampleControls"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                className="d-block w-100 home_image"
                src="https://m.media-amazon.com/images/I/613-gA49v1L._SX3000_.jpg"
                alt="First slide"
              />
            </div>
            <div className="carousel-item">
              <img
                className="d-block w-100 home_image"
                src="https://m.media-amazon.com/images/I/71usv3CIbTL._SX3000_.jpg"
                alt="Second slide"
              />
            </div>
            <div className="carousel-item">
              <img
                className="d-block w-100 home_image"
                src="https://m.media-amazon.com/images/I/61mZ60Ci3YL._SX3000_.jpg"
                alt="Third slide"
              />
            </div>
          </div>
          <a
            className="carousel-control-prev"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
        <div className="home__product">
          <div className="home__row">
            <Product
              id="1234567"
              title="Who Will Cry When You Die?"
              image="https://m.media-amazon.com/images/I/41wKll7ITyL._AC_UY327_FMwebp_QL65_.jpg"
              price={19.99}
              rating={5}
            />
            <Product
            id="1234521"
              title="Fire-Boltt Ninja Call Pro Plus 1.83 Smart Watch  Smart Watch with Bluetooth Calling"
              image="https://m.media-amazon.com/images/I/61Q0R5cdxWL._AC_UL480_FMwebp_QL65_.jpg"
           price={26} rating={4} />
            <Product id="1232114" title="OnePlus Buds Pro 2  Bluetooth Truly Wireless in Ear Earbuds with Spatial Audio Dynamic Head Tracking,"
            image="https://m.media-amazon.com/images/I/51G-nCt3mKL._AC_UL480_FMwebp_QL65_.jpg"
            price={120}
            rating={3}
            />
          </div>
          <div className="home__row">
          <Product
          id="1232115"
              title="TANUJ Wood MART Solid Sheesham Wood 4 Seater Dining Table Set Dining Table with 4 Cushion Chairs"
              image="https://m.media-amazon.com/images/I/71Ar15Ki1jL._SX522_.jpg"
              price={150}
              rating={5}
            />
            <Product
            id="1232116"
              title="Lakmé 9To5 Primer + Matte Perfect Cover Foundation, N200 Neutral Nude, 25 ml"
              image="https://m.media-amazon.com/images/I/41deWtUrpNL._SX522_.jpg"
           price={5} rating={4} />
            <Product
            id="1232119" title="Samsung 244 L 3 Star Frost-Free Double Door Refrigerator"
            image="https://m.media-amazon.com/images/I/51MOlbIsrnL._SL1000_.jpg"
            price={500}
            rating={4}
            />

          </div>
          <div className="home__row">
          <Product
          id="1232111"
              title="MULTI ZONE Crystal Clear Toughened Glass Tea Cup with Convenient Solid Handle Cups"
              image="https://m.media-amazon.com/images/I/516X+uXX2xL.jpg"
              price={6}
              rating={4}
            />
            <Product
            id="1232112"
              title="JBL Cinema SB241, Dolby Digital Soundbar with Wired Subwoofer for Extra Deep Bass,"
              image="https://m.media-amazon.com/images/I/61tg0idP5cL._SX522_.jpg"
           price={26} rating={4} />
            <Product
            id="1232110"
            title="TP-Link Archer AC1200 Archer C6 Wi-Fi Speed Up to 867 Mbps/5 GHz + 400 Mbps/2.4 GHz"
            image="https://m.media-amazon.com/images/I/51ax8peHlPL._SX679_.jpg"
            price={70}
            rating={5}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
